export default function (locale) {
  return locale.replace('_', '-');
}
